import queryString from 'query-string';
import urls from '../urls';
import { getHostEnv } from '../util/url';

export function parseAuthQuery() {
  const href: string = window.location.href;
  const parsedQuery = queryString.parse(queryString.extract(href));

  const code: string = ((parsedQuery.code as string) || '').replace(/#$/, ''); // Google login seems to append this
  const clientId: string = parsedQuery.clientId as string;
  return { code, clientId };
}

interface LoginState {
  subdomain?: string;
  clientId?: string;
  app?: string;
  destination?: string;
  redirectDomain?: string;
}

interface LoginQueryParams {
  codeChallenge: string;
  accountId: string;
  clientId?: string;
}

export function generateLoginUrl({
  codeChallenge,
  accountId,
}: LoginQueryParams) {
  const state: LoginState = {};
  const appPath = window.location.pathname.substr(1);
  const destination = window.location.search;

  if (accountId) {
    state.subdomain = accountId;
  }

  if (appPath) {
    state.app = appPath;
  }

  if (destination) {
    state.destination = destination;
  }

  if (!(getHostEnv() !== 'dev')) {
    state.redirectDomain = `${window.location.protocol}//${window.location.host}`;
  }

  const qs = queryString.stringify({
    codeChallenge,
    redirectUri: urls.loginRedirect,
    state: btoa(JSON.stringify(state)),
  });

  return `${urls.oauth2Authorize}?${qs}`;
}
